import { Container } from 'src/components/Container/Container'
import { ProductCard } from 'src/components/ProductCard/ProductCard'
import styles from 'src/components/ProductGrid/ProductGrid.module.scss'
import { findProductAndVariantBySku } from 'src/functions/product/findProductAndVariantBySku'

import type { Product } from 'src/data/graphql-generated'
import type { ProductRating } from 'src/types/Product'

export interface CmsProductGridProps {
  products: Product[]
  skus: string[]
  ratings?: Record<string, ProductRating>
}

export const CmsProductGrid = ({ products, skus, ratings = {} }: CmsProductGridProps) => (
  <Container className={styles.container}>
    <div className={styles.productGrid}>
      {skus.map((sku, index) => {
        const { product, variant } = findProductAndVariantBySku(products, sku)

        if (!product) return null
        // eslint-disable-next-line react/no-array-index-key
        return <ProductCard product={product} variant={variant} rating={ratings[sku]} key={`${product.id}${index}`} />
      })}
    </div>
  </Container>
)
